<template>
	<div :id="advanced.cssId" :class="['payment-form loading', advanced.cssClasses, addedClass, responsiveClasses]"
	     :style="style">
		<div class="spinner">
			<svg xmlns="http://www.w3.org/2000/svg" width="28px" height="28px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
				<circle cx="50" cy="50" fill="none" stroke="currentColor" stroke-width="4" r="34"
				        stroke-dasharray="70 25" transform="rotate(73.7169 50 50)">
					<animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.6134969325153374s"
					                  values="0 50 50;360 50 50" keyTimes="0;1"/>
				</circle>
			</svg>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"
import {boxShadow, getPadding} from "@/modules/page-editor/src/utils/props";

export default {
	name: 'emailPaymentForm',
	props: ['id', 'addedClass', 'details'],
	data: function () {
		return {
			step: 1,
			plusInputBtnActive: false,
			paymentMethodsValue: '',
		}
	},
	computed: {
		...mapGetters(['page_findOne', 'page_findChild']),
		content() {
			return this.details
		},
		basic() {
			return this.content ? this.content.attributes.basic : false
		},
		advanced() {
			return this.content ? this.content.attributes.advanced : false
		},
		responsive() {
			return this.details.responsive
		},
		responsiveClasses() {
			let c = '';
			if (!this.responsive) return '';
			if (!this.responsive.desktop) c = 'no-desktop';
			if (!this.responsive.mobile) c += ' no-mobile';
			if (!this.responsive.tablets) c += ' no-tablet';
			return c;
		},
		style() {
			let transform = this.advanced.transformation ?
					'rotateX(' + this.advanced.transformation.rotateX + 'deg) ' +
					'rotateY(' + this.advanced.transformation.rotateY + 'deg) ' +
					'rotateZ(' + this.advanced.transformation.rotateZ + 'deg) ' +
					'scale3d(' + this.advanced.transformation.scaleX + ', ' + this.advanced.transformation.scaleY + ', ' +
					this.advanced.transformation.scaleZ + ')' : null;

			let transition = this.advanced.animations ?
					this.advanced.animations.duration + 's ' +
					this.advanced.animations.property + ' ' +
					this.advanced.animations.easing : null;

			return {
				margin: getPadding(this.basic.margin),
				backgroundColor: this.basic.backgroundColor,
				boxShadow: boxShadow(this.basic.shadows),
				transform,
				transition,
			}
		}
	},
	methods: {},
}
</script>
<style lang="scss" >
.payment-form {
	position: relative;
	overflow: hidden;
}
</style>
